import { useKeywordSearchParam, useTypedSearchParams } from '@/hook';
import { VFlex, VInput, VSelect } from '@/package';
import type { ModelingListSearchParams } from '@/type';

const DeploymentPageHeader = () => {
  const { get, set, flush } = useTypedSearchParams<ModelingListSearchParams>();
  const { keyword, onKeywordChange } = useKeywordSearchParam({
    searchParamKey: 'modelingKeyword',
  });

  return (
    <VFlex className="py-4.5" justify="between" items="center">
      <VInput
        placeholder="Search"
        type="search"
        value={keyword}
        onChange={onKeywordChange}
      />

      <div className="w-[78px]">
        <VSelect
          value={get('modelingLimit') as string}
          onChange={e => {
            set('modelingLimit', e._target.value);
            flush();
          }}
          itemList={[
            { label: '20ea', value: '20' },
            { label: '10ea', value: '10' },
          ]}
          fluid
        />
      </div>
    </VFlex>
  );
};

export default DeploymentPageHeader;
